import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import DefaultView from "../components/DefaultView";
import { connect } from "react-redux";
import {
  actionGetVerifiedPhoneFaxNumbers,
  actionDeleteVerifiedNumber,
} from "../store/actions/authAction";
import moment from "moment";
import NumberExportToExcel from "../components/NumberExportToExcel";
import NumberExportToPDF from "../components/NumberExportToPDF";
import Swal from "sweetalert2";

function VerifiedPhoneFaxNumbersList({
  actionGetVerifiedPhoneFaxNumbers,
  verifiedPhoneFaxNumbers,
  getVerifiedPhoneFaxNumbersLoader,
  actionDeleteVerifiedNumber,
  deleteVerifiedNumberLoader,
  user,
}) {
  const [filterQuery, setFilterQuery] = useState("");
  const [filterQueryResult, setFilterQueryResult] = useState([]);
  const [selectedType, setSelectedType] = useState("");

  useEffect(() => {
    // Check if both start and end dates are selected
    const filtered =
      verifiedPhoneFaxNumbers &&
      verifiedPhoneFaxNumbers.filter(
        (record) =>
          (record.number.toLowerCase().includes(filterQuery.toLowerCase()) ||
            record.type.includes(filterQuery.toLowerCase())) &&
          (!selectedType || record.type === selectedType)
      );
    setFilterQueryResult(filtered);
  }, [filterQuery, selectedType, verifiedPhoneFaxNumbers]);

  useEffect(() => {
    user && actionGetVerifiedPhoneFaxNumbers(user.user_ID);
  }, [user]);

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  const handleDeleteNumber = (number) => {
    // Confirmation using SweetAlert2
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to delete this number?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then((result) => {
      if (result.isConfirmed) {
        actionDeleteVerifiedNumber(user.user_ID, number);
      }
    });
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* start page title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 main_heading">
                  Verified Phone / Fax Numbers{" "}
                </h4>
                <div className="page-title-right">
                  <DefaultView />
                </div>
              </div>
            </div>
          </div>
          {/* end page title */}
          <div className="row">
            <div className="col-lg-12">
              {/* start card */}
              <div className="d-flex justify-content-end my-2">
                <Link
                  to={"/add-verified-phone-fax-number"}
                  className="btn btn-primary buttons-html5"
                >
                  Add New Number
                </Link>
              </div>
              <div className="card invoiceCard">
                <div className="card-header">
                  <h4 className="card-title">Phone / Fax Number List</h4>
                  <p className="card-title-desc">
                    Here, you will find your verified phone/fax number. Use this
                    number to configure and redirect your fax service.
                  </p>
                </div>
                <div className="row d-none">
                  <div className="col-lg-4">
                    <div className="classic-colorpicker" />
                  </div>
                  <div className="col-lg-4">
                    <div className="monolith-colorpicker" />
                  </div>
                  <div className="col-lg-4">
                    <div className="nano-colorpicker" />
                  </div>
                </div>
                <div className="card-body">
                  <div
                    id="datatable-buttons_wrapper"
                    className="dataTables_wrapper dt-bootstrap4 no-footer"
                  >
                    <div className="dateSearch mb-3">
                      <div className="row">
                        <div className="col-sm-12 col-md-6">
                          <div className="mb-3">
                            <label>Filter By Type: </label>
                            <select
                              className="form-select"
                              onChange={handleTypeChange}
                            >
                              <option value={""}>Select Type</option>
                              <option value={"PHONE"}>Phone</option>
                              <option value={"FAX"}>Fax</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6">
                          <div
                            id="datatable-buttons_filter"
                            className="dataTables_filter"
                          >
                            <div className="d-flex align-items-start flex-column">
                              <label>Search:</label>
                              <input
                                type="search"
                                className="form-control"
                                placeholder="Search item"
                                aria-controls="datatable-buttons"
                                value={filterQuery}
                                onChange={(e) => setFilterQuery(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="table-responsive">
                          {getVerifiedPhoneFaxNumbersLoader && (
                            <div className="text-center">Loading</div>
                          )}
                          {!getVerifiedPhoneFaxNumbersLoader && (
                            <table
                              id="datatable-buttons"
                              className="invoiceTable table table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                              role="grid"
                              aria-describedby="datatable-buttons_info"
                              style={{ width: 1253 }}
                            >
                              <thead>
                                <tr role="row">
                                  <th
                                    className="sorting sorting_asc"
                                    tabIndex={0}
                                    rowSpan={1}
                                    colSpan={1}
                                  >
                                    Sr. No
                                  </th>
                                  <th
                                    className="sorting"
                                    tabIndex={0}
                                    rowSpan={1}
                                    colSpan={1}
                                  >
                                    Number
                                  </th>

                                  <th
                                    className="sorting text-center"
                                    tabIndex={0}
                                    rowSpan={1}
                                    colSpan={1}
                                  >
                                    Type
                                  </th>
                                  <th
                                    className="sorting text-center"
                                    tabIndex={0}
                                    rowSpan={1}
                                    colSpan={1}
                                  >
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {filterQueryResult.map((item, index) => (
                                  <tr role="row" key={index}>
                                    <th
                                      className="sorting sorting_asc"
                                      tabIndex={0}
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      {index + 1}
                                    </th>
                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      {item.number}
                                    </th>

                                    <th
                                      className="sorting text-center"
                                      tabIndex={0}
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      {item.type == "FAX" && (
                                        <i className="fa fa-fax fa-2x" />
                                      )}

                                      {item.type == "PHONE" && (
                                        <i className="fa fa-mobile fa-2x" />
                                      )}
                                    </th>
                                    <th
                                      className="sorting text-center"
                                      tabIndex={0}
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      <button
                                        onClick={() =>
                                          handleDeleteNumber(item.number)
                                        }
                                        className="btn btn-outline btn-danger btn-sm mx-1"
                                        title="Delete Number"
                                        disabled={deleteVerifiedNumberLoader}
                                      >
                                        {deleteVerifiedNumberLoader ? (
                                          <i
                                            className="fas fa-spinner fa-spin"
                                            title="Loading"
                                          ></i>
                                        ) : (
                                          <i
                                            className="fas fa-trash"
                                            title="Delete Number"
                                          />
                                        )}
                                      </button>
                                    </th>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* end card */}
            </div>
            {/* end col */}
          </div>
        </div>
        {/* container-fluid */}
      </div>
      {/* End Page-content */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    verifiedPhoneFaxNumbers: state.auth.verifiedPhoneFaxNumbers,
    deleteVerifiedNumberLoader: state.auth.deleteVerifiedNumberLoader,
    getVerifiedPhoneFaxNumbersLoader:
      state.auth.getVerifiedPhoneFaxNumbersLoader,
  };
};

export default connect(mapStateToProps, {
  actionGetVerifiedPhoneFaxNumbers,
  actionDeleteVerifiedNumber,
})(VerifiedPhoneFaxNumbersList);
